import { CommonModule } from '@angular/common';
import { Component, Input, ElementRef, AfterViewInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  imports: [CommonModule],
  templateUrl: './tooltip.component.html',
  host: {
    '[class.w-full]': 'fullWidth',
    '[class.min-w-0]': 'fullWidth',
    '[class.flex]': 'fullWidth',
    '[class.inline-flex]': '!fullWidth'
  }
})
export class TooltipComponent implements AfterViewInit {
  @Input() text = '';     
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() fullWidth = false;

  @ViewChild('tooltipContent', { static: false }) tooltipContent?: ElementRef;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.setupTooltipPosition();
  }

  private setupTooltipPosition() {
    const container = this.el.nativeElement.querySelector('.group\\/tooltip');
    const content = this.el.nativeElement.querySelector('ng-content');
    const tooltip = this.el.nativeElement.querySelector('.fixed');

    if (!container || !tooltip) return;

    // Listen to mouse enter on container
    this.renderer.listen(container, 'mouseenter', () => {
      this.updateTooltipPosition(container, tooltip);
    });

    // Update on scroll
    this.renderer.listen(window, 'scroll', () => {
      if (tooltip.classList.contains('opacity-0') === false) {
        this.updateTooltipPosition(container, tooltip);
      }
    });
  }

  private updateTooltipPosition(container: HTMLElement, tooltip: HTMLElement) {
    const rect = container.getBoundingClientRect();
    
    if (this.position === 'top') {
      const left = rect.left + rect.width / 2;
      const top = rect.top - 12; // mb-3 (12px spacing)
      
      this.renderer.setStyle(tooltip, 'left', `${left}px`);
      this.renderer.setStyle(tooltip, 'top', `${top}px`);
      this.renderer.setStyle(tooltip, 'transform', 'translate(-50%, -100%)');
    } else if (this.position === 'bottom') {
      const left = rect.left + rect.width / 2;
      const top = rect.bottom + 12; // mt-3 (12px spacing)
      
      this.renderer.setStyle(tooltip, 'left', `${left}px`);
      this.renderer.setStyle(tooltip, 'top', `${top}px`);
      this.renderer.setStyle(tooltip, 'transform', 'translateX(-50%)');
    }
  }
}

